import { render, staticRenderFns } from "./DeactivateAlert.vue?vue&type=template&id=441c479d"
import script from "./DeactivateAlert.vue?vue&type=script&lang=js"
export * from "./DeactivateAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports